export const allMenuItems = [
    { label: "Show All Courses", key: "all" },
    { label: "Show Active Courses", key: "active" },
    { label: "Show Inactive Courses", key: "inactive" },
];

export const tabList = [
  { key: "active", label: "Active" },
  { key: "inactive", label: "Inactive" },
];